import { OceanBlock } from "../maps/mapmanager";
import type { GameContext, GameMiddleware } from "./types";

/**
 * Drives OceanBlock texture animation each frame.
 *
 * Previously split across two places:
 *   - MapManager.update() called OceanBlock.update() when a map was loaded
 *   - rose-editor.ts onUpdate() called it directly so water animates
 *     even without a loaded map (manually-placed water objects)
 *
 * Both calls are removed in favour of this middleware, which always runs.
 */
export class OceanMiddleware implements GameMiddleware {
    init(_ctx: GameContext): void {}

    update(delta: number): void {
        OceanBlock.update(delta);
    }
}
